import { useEffect, useState } from 'react';

const BREAKPOINTS = {
  mobile: 480,
  tablet: 768,
  desktop: 1024,
};

export function useResponsive() {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    width: windowSize.width,
    height: windowSize.height,
    isMobile: windowSize.width <= BREAKPOINTS.mobile,
    isTablet:
      windowSize.width > BREAKPOINTS.mobile &&
      windowSize.width <= BREAKPOINTS.tablet,
    isDesktop: windowSize.width > BREAKPOINTS.tablet,
    isMobileOrTablet: windowSize.width <= BREAKPOINTS.tablet,
    breakpoint:
      windowSize.width <= BREAKPOINTS.mobile
        ? 'mobile'
        : windowSize.width <= BREAKPOINTS.tablet
          ? 'tablet'
          : 'desktop',
  };
}
